import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useMuiTheme } from '../../contexts/MuiThemeContext';// import { logger } from "../../utils/logger";
interface ThemeToggleProps {
  showTooltip?: boolean;
  size?: 'small' | 'medium' | 'large';
  sx?: any;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  showTooltip = true, 
  size = 'medium',
  sx = {}
}) => {
  const { mode, toggleTheme } = useMuiTheme();

  const button = (
    <IconButton
      onClick={toggleTheme}
      color="inherit"
      size={size}
      sx={{
        p: { xs: 2, md: 1.5 },
        minWidth: { xs: 44, md: 'auto' },
        minHeight: { xs: 44, md: 'auto' },
        backgroundColor: 'rgba(102, 126, 234, 0.1)',
        borderRadius: 2,
        '&:hover': {
          backgroundColor: 'rgba(102, 126, 234, 0.2)',
          transform: 'scale(1.05)',
        },
        transition: 'all 0.2s ease-in-out',
        ...sx
      }}
      aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
    >
      {mode === 'light' ? 
        <DarkMode sx={{ fontSize: { xs: 22, md: 20 } }} /> : 
        <LightMode sx={{ fontSize: { xs: 22, md: 20 } }} />
      }
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default ThemeToggle; 
